// TB-096: classify "the session is dead → route to re-auth" errors vs. ordinary
// data/network errors. Shared by App.js (data-fetch catch blocks + Hub listener) and
// useUserData.js (loadUserData), so the two stay in lockstep.
//
// Conservative BY DESIGN. It matches ONLY:
//   - named Amplify auth-empty types (NoSignedUser / NoValidAuthTokens / UserUnAuthenticatedException)
//   - Cognito/AppSync token-expiry rejections (NotAuthorizedException / UnauthorizedException
//     whose message names an expired/invalid token)
// It deliberately does NOT match:
//   - network errors (TypeError / NetworkError) → never sign a user out on flaky wifi
//   - a wrong password (NotAuthorizedException "Incorrect username or password") → no token text
//
// AppSync/GraphQL surface the signal inside err.errors[].errorType/message, so we check the
// top-level error AND any nested GraphQL errors.
export function isAuthExpiry(err) {
  if (!err) return false;
  const candidates = [err, ...(Array.isArray(err.errors) ? err.errors : [])];
  for (const e of candidates) {
    if (!e) continue;
    const name = e.name || e.errorType || '';
    const msg = (e.message || '').toLowerCase();
    if (name === 'NoSignedUser' || name === 'NoValidAuthTokens' || name === 'UserUnAuthenticatedException') {
      return true;
    }
    if ((name === 'NotAuthorizedException' || name === 'UnauthorizedException') && (
      msg.includes('invalid login token') ||
      msg.includes('token has expired') ||
      msg.includes('access token has expired') ||
      msg.includes('refresh token')
    )) {
      return true;
    }
  }
  return false;
}
